<template>
    <div>
        <div v-if="paginatedAlerts && paginatedAlerts.length > 0"
             :class="classesForUnread"
        >
            <span class="ml-3 sb-notification-span">YOU HAVE {{ alert_count }} UNREAD NOTIFICATIONS.</span>
            <div v-for="(sbalert, index) in paginatedAlerts"
                 :class="'opportunity-bullet alert alert-'+getPriority(sbalert.priority)+' mb-2 mr-3 ml-3'+(sbalert.read_at == null ? '' : ' d-none')"
                 role="alert">

                <span v-if="sbalert.custom_subject">
                    <i class="fas fa-exclamation-circle mr-2"></i>{{ sbalert.custom_subject }}
                </span>
                <span v-else>
                    <i class="fas fa-exclamation-circle mr-2"></i>{{ sbalert.subject }}
                </span>
                <br/>
                <!-- Button trigger modal -->
                <a class="learn-more-lnk" href="#" data-toggle="modal" @click="readAlert(index,sbalert)"
                   :aria-label="('Learn More - ' + (sbalert.custom_subject ? sbalert.custom_subject : sbalert.subject))"
                   data-target="#alertModal">Learn More</a>
            </div>
        </div>

        <div v-else
             class="text-center"
             :class="classesForUnread"
        >
            <div class="alert">There are no new notifications available at this time</div>
        </div>

        <pagination
            v-if="showPagination"
            :records="alert_count"
            v-model="page"
            :per-page="perPage"
            :options="options"
        ></pagination>

        <div class="mb-3 sbalerts sbalerts_read" v-if="showunread === 'true' && alertsread && alertsread.length > 0">
            <span class="ml-3 sb-notification-span">READ NOTIFICATIONS</span>
            <div v-for="(sbalert, index) in paginatedAlertsRead"
                 :class="'opportunity-bullet alert alert-'+getPriority(sbalert.priority)+' mb-2 mr-3 ml-3'"
                 role="alert">
                <i class="fas fa-exclamation-circle mr-2"></i>
                <span v-if="sbalert.custom_subject">
                    {{ sbalert.custom_subject }}
                </span>
                <span v-else>
                    {{ sbalert.subject }}
                </span>

                <button type="button" class="btn btn-danger float-right" data-dismiss="alert"
                        :aria-label="('Delete - ' + (sbalert.custom_subject ? sbalert.custom_subject : sbalert.subject))"
                        @click="deleteAlert(index,sbalert)">
                    Delete
                </button>
                <br/>
                <!-- Button trigger modal -->
                <a class="learn-more-lnk" href="#" data-toggle="modal" @click="readAlert(index,sbalert)"
                   :aria-label="('Learn More - ' + (sbalert.custom_subject ? sbalert.custom_subject : sbalert.subject))"
                   data-target="#alertModal">Learn More</a>
            </div>
        </div>

        <pagination
            v-if="showReadPagination"
            :records="read_alert_count"
            v-model="readPage"
            :per-page="perPage"
            :options="options"
        ></pagination>

        <!-- Modal -->

        <div class="modal fade" id="alertModal" tabindex="-1" role="dialog" aria-labelledby="alertModalLabel"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="alertModalLabel">
                            <span v-if="sbalert.custom_subject">
                                {{ sbalert.custom_subject }}
                            </span>
                            <span v-else>
                                {{ sbalert.subject }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pb-0"><b>Received:</b> {{formatDate(sbalert.created_at)}}</div>
                    <div class="modal-body" v-html="sbalert.message">
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from 'vue-pagination-2';

export default {
    props: [
        'alerts',
        'showunread',
        'alertsread',
        'showPaginate',
        'showReadPaginate',
    ],
    components: {
        Pagination
    },
    data() {
        return {
            route: '/api/alert-read',
            alert_count: 0,
            read_alert_count: 0,
            alerts_unread: [],
            alerts_read: [],
            sbalert: {
                subject: '',
                use_id: '',
                custom_subject: '',
                message: '',
                created_at: ''
            },
            page: 1,
            readPage: 1,
            perPage: 5,
            options: {
                'chunk': 5,
                'theme': 'bootstrap4'
            },
            showPagination: this.showPaginate && this.alerts && this.alerts.length > 5,
            showReadPagination: this.showReadPaginate && this.alertsread && this.alertsread.length > 5
        }
    },
    mounted() {
        this.alerts_unread = this.alerts;
        this.alerts_read = this.alertsread;

        this.alert_count = this.alerts?this.alerts.length:0;
        this.read_alert_count = this.alerts_read?this.alerts_read.length:0;
        if (this.showPagination) this.createSelectPerPage();
        this.$nextTick(() => {
            this.addLabelToPaginationButtons();

            // Delete pagination scrolling buttons that are easily confused for first/last page buttons.
            let prevChunkLi = document.querySelector('.VuePagination__pagination-item-prev-chunk');
            if (prevChunkLi) {
                prevChunkLi.parentNode.removeChild(prevChunkLi);
            }

            let nextChunkLi = document.querySelector('.VuePagination__pagination-item-next-chunk');
            if (nextChunkLi) {
                nextChunkLi.parentNode.removeChild(nextChunkLi);
            }
        });
    },
    computed: {
        paginatedAlerts() {
            const start = this.page * this.perPage - this.perPage;
            return this.alerts_unread.slice(start, start + this.perPage);
        },
        paginatedAlertsRead() {
            const start = this.readPage * this.perPage - this.perPage;
            return this.alerts_read.slice(start, start + this.perPage);
        },
        classesForUnread() {
            if (this.showPagination) return "mb-3 sbalerts";
            if (this.alert_count === 0) return "mb-40 sbalerts";
            return "mb-62 sbalerts";
        }
    },
    methods: {
        readAlert(key, value) {
            this.sbalert = value;

            if (value.read_at == null) {
                this.$http.post(this.route, this.sbalert)
                    .then(function () {
                        $('#alert_count').html($('#alert_count').html() == 0 ? 0 : $('#alert_count').html() - 1);
                        this.alert_count--;
                        this.alerts_unread.splice(key, 1)
                        this.alertsread.push(value)
                    }, () => {})
            }
        },
        deleteAlert(key, value) {
            this.sbalert = value
            this.$http.post(this.route + '/delete', this.sbalert)
                .then(function () {
                    this.alertsread.splice(key, 1)
                }, () => {})
        },
        getTimeStamp() {
            var currentdate = new Date();
            return currentdate.getDate() + "/"
                + (currentdate.getMonth() + 1) + "/"
                + currentdate.getFullYear() + " @ "
                + currentdate.getHours() + ":"
                + currentdate.getMinutes() + ":"
                + currentdate.getSeconds();
        },
        getPriority(priority) {
            return {
                'low': 'success',
                'medium': 'warning',
                'high': 'danger'
            }[priority] || 'success';
        },
        createSelectPerPage() {
            const selectPerPage = document.createElement('select');
            selectPerPage.id = 'select-per-page';
            selectPerPage.name = 'select-per-page';
            selectPerPage.innerHTML = '<option value="5" selected>5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option><option value="100">100</option>';
            selectPerPage.addEventListener('change', this.changePerPage, false);

            const infoBlock = document.getElementsByClassName('VuePagination__count')[0];
            infoBlock.parentNode.insertBefore(selectPerPage, infoBlock.nextSibling);
        },
        changePerPage() {
            this.page = 1;
            this.perPage = parseInt(document.getElementById('select-per-page').value);
        },
        addLabelToPaginationButtons() {
            var pageLinks = $('li .page-link');
            pageLinks.each(function() {
                var aTagValue = $(this).text();
                $(this).attr('aria-label', 'Page ' + aTagValue);
                $(this).attr('tabindex', 0);
                $(this).attr('href', 'javascript:void(0)');
            });
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();
            const ampm = hours >= 12 ? ' PM' : ' AM';
            const formattedHours = hours % 12 || 12;
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
            const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;
            return `${month}/${day}/${date.getFullYear()} ${formattedHours}:${formattedMinutes}:${formattedSeconds}${ampm}`;
        }
    }
}
</script>
